import React from 'react'
import { MiFooter } from '../../components/footer/MiFooter'
import { ContentBodyServiciosOfrecidos } from '../../components/serviciosOfrecidos/ContentBodyServiciosOfrecidos'
import './serviciosOfrecidos.css'
import { useContext } from 'react'
import { UsuarioContext } from '../../contexts/UsuarioContext'
import HeaderHome from '../../components/headerHome/HeaderHome'

export const ServiciosOfrecidos = () => {

  const [MenuLateral, setMenuLateral] = useContext(UsuarioContext)
  const closeMenu = () => {
    if (MenuLateral === true) {
      setMenuLateral(false)
    }
  }
  return (
    <div className='ServiciosOfrecidos' onClick={closeMenu} >
      <div className='headerServiciosOfrecidos'>
        <HeaderHome />
      </div>
      <div className="bodyServiciosOfrecidos">
        <ContentBodyServiciosOfrecidos />
      </div>
      <div className='footerReservarServicio'>
        <MiFooter />
      </div>
    </div>
  )
}
